import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { platformAPI } from '../../../services/platformAPI';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

const PursuitRulesPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [message, setMessage] = useState(null);
  useDocumentTitle('Pursuit reminders');
  useEffect(() => {
    platformAPI.getPursuitSettings()
      .then((response) => setForm(response.data?.data?.settings))
      .catch((error) => setMessage({ variant: 'danger', text: error.response?.data?.message || 'Unable to load reminder rules' }));
  }, []);
  const save = async (event) => {
    event.preventDefault();
    try {
      const response = await platformAPI.updatePursuitSettings(form);
      setForm(response.data?.data?.settings);
      setMessage({ variant: 'success', text: 'Reminder rules saved for this workspace.' });
    } catch (error) {
      setMessage({ variant: 'danger', text: error.response?.data?.message || 'Unable to save reminder rules' });
    }
  };
  if (!form) return <Spinner animation="border" size="sm" />;
  const set = (name) => (event) => setForm({ ...form, [name]: Number(event.target.value) });
  return (
    <div className="cust-page">
      <button type="button" className="cust-page__back" onClick={() => navigate('/apps/tender/settings')}><BiArrowBack /> Settings</button>
      <h1 className="h4">Pursuit reminders</h1>
      <p className="text-muted">{form.note}</p>
      {message ? <Alert variant={message.variant}>{message.text}</Alert> : null}
      <form className="row g-3" onSubmit={save}>
        <Form.Group className="col-md-3"><Form.Label>Security expiry lead (days)</Form.Label><Form.Control type="number" min="0" value={form.securityExpiryLeadDays} onChange={set('securityExpiryLeadDays')} /></Form.Group>
        <Form.Group className="col-md-3"><Form.Label>Claim expiry lead (days)</Form.Label><Form.Control type="number" min="0" value={form.securityClaimLeadDays} onChange={set('securityClaimLeadDays')} /></Form.Group>
        <Form.Group className="col-md-3"><Form.Label>Release follow-up (days)</Form.Label><Form.Control type="number" min="0" value={form.releaseFollowUpDays} onChange={set('releaseFollowUpDays')} /></Form.Group>
        <Form.Group className="col-md-3"><Form.Label>Pre-bid reminder lead (days)</Form.Label><Form.Control type="number" min="0" value={form.preBidReminderLeadDays} onChange={set('preBidReminderLeadDays')} /></Form.Group>
        <div className="col-12"><Button size="sm" type="submit">Save</Button></div>
      </form>
      <p className="small text-muted mt-3">A daily check assigns an in-app My Work item to the record owner when an expiry, claim date, release follow-up, or pre-bid deadline falls inside these lead times. The same item is not created again if the job runs twice. Changing the date cancels the previous reminder. Email is not sent, and the notice says so. A confirmed corrigendum deadline is also an in-app notice.</p>
    </div>
  );
};

export default PursuitRulesPage;
